import {DataServiceBase} from "../DataServiceBase";

export class ExternalAuthService extends DataServiceBase {
    constructor() {
        super('/api/AuthToken/token');
    }
}
